import { NotificationTwoTone } from '@ant-design/icons';
import { Select, Space } from 'antd';
import React from 'react';

import type { ProgramDetailValues } from '../../../../types';
import type { AmountOptions } from '../../types';
import { getGridBoxClassName, getSelectAmountOptions } from './helpers';
import styles from './index.module.scss';

type PricingSectionProps = {
  pricing: ProgramDetailValues['pricing'];
  amountOptions: AmountOptions | undefined;
};

export const PricingSection = ({
  pricing,
  amountOptions,
}: PricingSectionProps) => {
  const memberAmountOptions = amountOptions
    ? getSelectAmountOptions(amountOptions.memberMaxSelectableAmount)
    : [];

  const nonMemberAmountOptions = amountOptions
    ? getSelectAmountOptions(amountOptions.nonMemberMaxSelectableAmount)
    : [];

  const { price: memberPrice, point: memberPoint } = pricing.member;
  const { price: nonMemberPrice, point: nonMemberPoint } = pricing.nonMember;

  const hasNonMemberPricing = nonMemberPrice || nonMemberPoint;
  const canOrderNonMember =
    amountOptions && amountOptions.nonMemberMaxSelectableAmount > 0;
  const showNonMember = hasNonMemberPricing && canOrderNonMember;

  const gridBoxClassName = getGridBoxClassName({
    hasMemberPrice: !!memberPrice,
    hasMemberPoint: !!memberPoint,
    showAmountColumn: !!amountOptions,
  });

  return (
    <div className={styles.section}>
      <Space direction="vertical" size="middle" className={styles['w-full']}>
        <Space>
          <NotificationTwoTone rev={undefined} />
          <h4 className={styles.sectionTitle}>育樂項目：</h4>
        </Space>
        <Space direction="vertical" className={styles['w-full']}>
          <div className={gridBoxClassName}>
            <p className={styles.gridTitle}>方案</p>
            {memberPrice ? <p className={styles.gridTitle}>台幣</p> : null}
            {memberPoint ? <p className={styles.gridTitle}>點數</p> : null}
            {amountOptions ? <p className={styles.gridTitle}>數量</p> : null}

            <p>會員</p>
            {memberPrice ? <p>{memberPrice}元</p> : null}
            {memberPoint ? <p>{memberPoint}點</p> : null}
            {amountOptions ? (
              <Select
                placeholder="請選擇數量"
                options={memberAmountOptions}
                onSelect={(value) =>
                  amountOptions.onAmountChange('member', value)
                }
              />
            ) : null}

            {showNonMember && (
              <>
                <p>非會員</p>
                {nonMemberPrice ? <p>{nonMemberPrice}元</p> : null}
                {nonMemberPoint ? <p>{nonMemberPoint}點</p> : null}
                {amountOptions ? (
                  <Select
                    placeholder="請選擇數量"
                    options={nonMemberAmountOptions}
                    onSelect={(value) =>
                      amountOptions.onAmountChange('nonMember', value)
                    }
                  />
                ) : null}
              </>
            )}
          </div>
        </Space>
      </Space>
    </div>
  );
};
